import deployment from './analytics-deployment.cjs';

export const BOTGO_GOOGLE_TAG_ID = 'G-13FTK7PYJM';

export function resolveGoogleTagId(googleTagId, measurementId) {
  const tagId = googleTagId?.trim() || measurementId?.trim() || '';
  if (tagId && !/^G-[A-Z0-9]+$/.test(tagId)) {
    throw new Error('Google Analytics requires a valid GA4 measurement ID (G-...).');
  }
  return tagId;
}

export function validateGoogleAnalyticsBuild(env) {
  const tagId = resolveGoogleTagId(env.NEXT_PUBLIC_GOOGLE_TAG_ID, env.NEXT_PUBLIC_GA_MEASUREMENT_ID);
  const isProductionBuild = deployment.resolveAnalyticsDeployment(env) === 'production';
  if (isProductionBuild && env.NEXT_PUBLIC_ANALYTICS_TEST_ENABLED === 'true') throw new Error('Production cannot enable test analytics.');
  if (isProductionBuild && tagId !== BOTGO_GOOGLE_TAG_ID) {
    throw new Error(`BotGo production requires NEXT_PUBLIC_GOOGLE_TAG_ID=${BOTGO_GOOGLE_TAG_ID} at build time.`);
  }
  return { tagId, isProductionBuild };
}

export const ANALYTICS_HOSTNAMES = Object.freeze(['botgo.ai', 'www.botgo.ai']);

export function canUseProductionAnalytics({ hostname, protocol, deployment, nodeEnv, tagId }) {
  return nodeEnv === 'production'
    && deployment === 'production'
    && protocol === 'https:'
    && ANALYTICS_HOSTNAMES.includes(hostname)
    && tagId === BOTGO_GOOGLE_TAG_ID;
}

export const ANALYTICS_SITE_PREFIX = 'botgo';
export const PRODUCTION_DATABASE_REF = 'fvsvjvcweqrcaskdjvoo';
export function canUseTestAnalytics({ hostname, protocol, deployment, nodeEnv, tagId, testEnabled, testHost, testId }) {
  const local = hostname === 'localhost' || hostname === '127.0.0.1';
  return testEnabled === true && hostname === testHost
    && !['botgo.ai', 'www.botgo.ai', 'sora2.design', 'www.sora2.design'].includes(hostname)
    && (deployment === 'preview' || (local && nodeEnv === 'development'))
    && (protocol === 'https:' || (local && protocol === 'http:'))
    && /^G-[A-Z0-9]+$/.test(testId || '') && tagId === testId
    && !['G-13FTK7PYJM', 'G-B64JD821GT'].includes(testId);
}
